/* Bright Solar Lights — “For fields & farms” section.
   Sits directly after “For homes”. Desktop: copy left, photo right.
   Mobile: heading and lede above the photo, features and button below it.
   The photo is a two-slide crossfade that switches every 2 seconds.

   Note: the stylesheet is injected once and keyed by version. Removing and
   re-adding it on every pass would retrigger the MutationObserver and lock
   up the renderer. */
(function () {
  var V = "6";
  var STYLE_ID = "bsl-farms-style-v" + V;
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MUTED = "#5F6259";
  var DELAY = 2000;
  var FADE = 500;

  var SLIDES = [
    {
      base: "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/hf_20260806_221944_b19563e9-1332-412c-b58a-5adf30e064c0.png?v=1786054872",
      alt: "Farm yard and gateway at dusk lit by a pole-mounted solar street light"
    },
    {
      base: "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/hf_20260806_224723_057e7d97-1eb7-4137-b132-a05bee546716.png?v=1786056566",
      alt: "Stable yard at dusk lit by a solar flood light with its panel mounted above"
    }
  ];

  var LINK = "/collections/fields-farms";

  var BULLETS = [
    "Farm yards, gateways and tracks",
    "Paddocks, stables and outbuildings",
    "Pole or wall mount, no electrician"
  ];

  function srcset(base) {
    return [600, 800, 1000, 1200, 1600]
      .map(function (w) { return base + "&width=" + w + " " + w + "w"; })
      .join(", ");
  }

  function tick() {
    return (
      '<span class="bsl-fm-chk" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" ' +
      'stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>'
    );
  }

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "#farms{border-top:1px solid rgba(23,26,21,.10)}",
      "#farms .bsl-fm-wrap{display:grid;grid-template-columns:1fr;gap:2.5rem;" +
        "align-items:center;max-width:78rem;margin:0 auto;padding:0 1.5rem}",
      "@media(min-width:1000px){#farms .bsl-fm-wrap{" +
        "grid-template-columns:minmax(0,1fr) minmax(0,1fr);column-gap:4.5rem}" +
        "#farms .bsl-fm-copy{order:1}#farms figure{order:2}}",

      "#farms figure{margin:0;position:relative}",

      /* mobile: heading and lede above the photo, features and button below */
      "@media(max-width:999px){" +
        "#farms .bsl-fm-wrap{gap:0}" +
        "#farms .bsl-fm-copy{display:contents}" +
        "#farms .bsl-fm-eyebrow{order:1}" +
        "#farms .bsl-fm-copy > h2{order:2}" +
        "#farms .bsl-fm-lede{order:3}" +
        "#farms figure{order:4;margin-top:1.7rem}" +
        "#farms .bsl-fm-copy > ul{order:5;margin-top:1.7rem}" +
        "#farms .bsl-fm-cta{order:6;justify-self:start}" +
      "}",

      "#farms .bsl-fm-stage{position:relative;width:100%;aspect-ratio:4/3;" +
        "border-radius:20px;overflow:hidden;background:#0F1210;" +
        "box-shadow:0 24px 60px rgba(23,26,21,.18)}",
      "#farms .bsl-fm-stage img{position:absolute;inset:0;width:100%;height:100%;" +
        "object-fit:cover;object-position:center;display:block;border:0;" +
        "opacity:0;transition:opacity " + FADE + "ms ease}",
      "#farms .bsl-fm-stage img.on{opacity:1}",
      "#farms .bsl-fm-dots{position:absolute;left:0;right:0;bottom:14px;display:flex;" +
        "justify-content:center;gap:.5rem;z-index:2}",
      "#farms .bsl-fm-dots button{width:8px;height:8px;padding:0;border:0;cursor:pointer;" +
        "border-radius:999px;background:rgba(255,255,255,.5);transition:background .25s ease,width .25s ease}",
      "#farms .bsl-fm-dots button[aria-current='true']{background:" + GOLD + ";width:22px}",

      "#farms .bsl-fm-float{position:absolute;left:-1.1rem;bottom:-1.6rem;background:#fff;" +
        "border-radius:14px;padding:1.05rem 1.3rem;max-width:16rem;z-index:3;" +
        "box-shadow:0 18px 44px rgba(23,26,21,.18)}",
      "#farms .bsl-fm-float b{display:block;font-size:1rem;font-weight:800;color:" + INK + ";line-height:1.25}",
      "#farms .bsl-fm-float span{display:block;margin-top:.35rem;font-size:.82rem;" +
        "line-height:1.45;color:" + MUTED + "}",
      "@media(max-width:999px){#farms .bsl-fm-float{position:static;margin-top:1rem;" +
        "max-width:none;box-shadow:none;border:1px solid rgba(23,26,21,.10)}}",

      "#farms .bsl-fm-eyebrow{display:block;font-size:.7rem;font-weight:700;" +
        "letter-spacing:.2em;text-transform:uppercase;color:" + GOLD + ";margin-bottom:1rem;" +
        "font-family:Inter,system-ui,sans-serif}",
      "#farms h2{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;" +
        "font-size:2.5rem;line-height:1.05;letter-spacing:-.03em;color:" + INK + ";margin:0}",
      "@media(min-width:1200px){#farms h2{font-size:3rem}}",
      "#farms h2 .hl{color:" + GOLD + "}",
      "#farms .bsl-fm-lede{margin:1.15rem 0 0;max-width:55ch;font-size:1rem;" +
        "line-height:1.65;color:" + MUTED + ";font-family:Inter,system-ui,sans-serif}",

      "#farms ul{list-style:none;margin:1.6rem 0 0;padding:0}",
      "#farms li{display:flex;align-items:center;gap:.85rem;padding:.42rem 0;" +
        "font-family:'JetBrains Mono',ui-monospace,monospace;font-size:.8rem;" +
        "letter-spacing:.06em;text-transform:uppercase;color:" + INK + "}",
      "#farms .bsl-fm-chk{width:26px;height:26px;border-radius:999px;background:" + GOLD + ";" +
        "display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;color:#fff}",

      "#farms .bsl-fm-cta{display:inline-flex;align-items:center;gap:.55rem;" +
        "margin-top:1.9rem;background:" + GOLD + ";color:" + INK + ";border-radius:999px;" +
        "padding:.95rem 1.6rem;font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;" +
        "font-weight:800;font-size:.95rem;text-decoration:none;" +
        "box-shadow:0 10px 26px rgba(245,168,0,.34);transition:transform .2s ease}",
      "#farms .bsl-fm-cta:hover{transform:translateY(-1px)}",
      "#farms .bsl-fm-cta::after{content:'\\2192';font-size:1rem;line-height:1}",

      "@media(prefers-reduced-motion:reduce){#farms .bsl-fm-stage img{transition:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function build() {
    var sec = document.createElement("section");
    sec.id = "farms";
    sec.dataset.bslV = V;
    sec.style.paddingTop = "3rem";
    sec.style.paddingBottom = "3rem";

    var imgs = SLIDES.map(function (s, i) {
      return (
        '<img class="' + (i === 0 ? "on" : "") + '" src="' + s.base + "&width=1200" + '" ' +
        'srcset="' + srcset(s.base) + '" sizes="(min-width:1000px) 46vw, 100vw" ' +
        'decoding="async" alt="' + s.alt + '">'
      );
    }).join("");

    var dots = SLIDES.map(function (s, i) {
      return (
        '<button type="button" data-i="' + i + '" aria-current="' + (i === 0) + '" ' +
        'aria-label="Show photo ' + (i + 1) + '"></button>'
      );
    }).join("");

    sec.innerHTML =
      '<div class="bsl-fm-wrap">' +
        '<div class="bsl-fm-copy">' +
          '<span class="bsl-fm-eyebrow">For fields &amp; farms</span>' +
          '<h2>Light where there’s no <span class="hl">power</span>.</h2>' +
          '<p class="bsl-fm-lede">Yards, gateways, tracks and paddocks. No trenching, ' +
            'no cable runs and no meter — these lights charge by day and run on ' +
            'their own all night.</p>' +
          "<ul>" +
            BULLETS.map(function (b) { return "<li>" + tick() + "<span>" + b + "</span></li>"; }).join("") +
          "</ul>" +
          '<a class="bsl-fm-cta" href="' + LINK + '">See field &amp; farm lights</a>' +
        "</div>" +
        "<figure>" +
          '<div class="bsl-fm-stage">' + imgs +
            '<div class="bsl-fm-dots">' + dots + "</div>" +
          "</div>" +
          '<div class="bsl-fm-float"><b>Built for open ground</b>' +
            "<span>Wide, even light across a yard or a gateway — dusk to dawn, " +
            "every night of the year.</span></div>" +
        "</figure>" +
      "</div>";
    return sec;
  }

  function slideshow(sec) {
    var stage = sec.querySelector(".bsl-fm-stage");
    if (!stage || stage.dataset.bslRun) return;
    stage.dataset.bslRun = "1";

    var imgs = stage.querySelectorAll("img");
    var dots = stage.querySelectorAll(".bsl-fm-dots button");
    var i = 0, timer = null;

    function show(n) {
      i = (n + imgs.length) % imgs.length;
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].classList.toggle("on", k === i);
        if (dots[k]) dots[k].setAttribute("aria-current", k === i ? "true" : "false");
      }
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, DELAY); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener("click", function (e) {
        show(parseInt(e.currentTarget.getAttribute("data-i"), 10));
        start();
      });
    }
    stage.addEventListener("mouseenter", stop);
    stage.addEventListener("mouseleave", start);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else start();
    });

    if (!window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches) start();
  }

  function place() {
    var existing = document.getElementById("farms");
    if (existing) {
      if (existing.dataset.bslV === V) { slideshow(existing); return; }
      existing.remove();
    }
    var homes = document.getElementById("homes");
    if (!homes || !homes.parentNode) return;
    var sec = build();
    homes.parentNode.insertBefore(sec, homes.nextSibling);
    slideshow(sec);
  }

  function run() { styles(); place(); }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
